export default "/react/logoNeuroShat-b80b67b6.png";